var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#171719"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8289 12.8891C22.8289 10.5112 24.7653 8.5835 27.154 8.5835C29.5427 8.5835 31.4791 10.5112 31.4791 12.8891C31.4791 15.2669 29.5427 17.1946 27.154 17.1946C25.9478 17.1946 24.8578 16.7029 24.0741 15.9117L18.0867 19.9883C18.1421 20.2634 18.1711 20.5475 18.1711 20.8378C18.1711 21.4126 18.0575 21.962 17.8515 22.4642L24.4167 26.7777C25.1618 26.1709 26.1153 25.8057 27.154 25.8057C29.5427 25.8057 31.4791 27.7334 31.4791 30.1113C31.4791 32.4892 29.5427 34.4168 27.154 34.4168C24.7653 34.4168 22.8289 32.4892 22.8289 30.1113C22.8289 29.4884 22.9622 28.8956 23.2018 28.3604L16.6897 24.0818C15.93 24.742 14.935 25.1433 13.8459 25.1433C11.4572 25.1433 9.52081 23.2157 9.52081 20.8378C9.52081 18.4599 11.4572 16.5322 13.8459 16.5322C15.2195 16.5322 16.4422 17.1695 17.2339 18.1614L23.0367 14.2105C22.9017 13.7936 22.8289 13.3492 22.8289 12.8891Z",
    fill: "#858B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.1caaaaff34a82575675217268ba223be.svg";
export { ForwardRef as ReactComponent };